export default "__VITE_ASSET__CNgBmSTb__"